export const TransactionColumnKeys = {
	TRANSACTION_ID: 'transactionId',
	CREATED_DATE: 'createdDate',
	CUSTOMER: 'customer',
	BOOKINGS: 'bookings',
	ENTITY_TYPE: 'entityType',
	TYPE: 'type',
	AMOUNT: 'amount',
	STATUS: 'status',
	LOCATION: 'location',
	CREATED_BY: 'createdBy',
} as const;

export type TransactionColumnKey = (typeof TransactionColumnKeys)[keyof typeof TransactionColumnKeys];
